module.exports = __webpack_public_path__ + "media/dashboard/author-c63d8cef.svg";